import request from 'utils/request'
import { LENGJ_HEADERS } from '@/config/lengj-index'

//司法信息
export const getJusticeInfo = data => {
  return request().post(
    'riskraider/v3/justice/getEnterpriseJusticeInfo',
    data,
    {
      headers: LENGJ_HEADERS,
    },
  )
}
//司法全景
export const getPanorama = data => {
  return request().post(
    'riskraider/v3/justice/getEnterpriseJudicialPanorama',
    data,
    {
      headers: LENGJ_HEADERS,
    },
  )
}
//企业裁判文书接口
export const getJudgment = data => {
  return request().post(
    'riskraider/v3/justice/getEnterpriseJudgmentPage',
    data,
    {
      headers: LENGJ_HEADERS,
    },
  )
}
